export const clemabread = {
  id: "clemabread",
  link: "/#/recipes/recipes/clemabread",
  name: "Clemabread",
  cuisine: "Tashikki",
  summary: "Oat rolls filled with a spicy paste",
  inspiration: "Harissa",
  quantity: "12",
  time: "2 1/2 hours",
  notes:
    "I broke my rules for this recipe. Below, you will find a version of this recipe that uses wheat flour, even though the Tashikki version that Lift ate would not have had gluten. I did this because, according to Lift, clemabread is not very tasty. I made a version without gluten, and it turned out exactly like Lift described it.  She said it broke apart easily, was closer to a mush, and was only slightly better than old gruel. My 100% oat flour version turned out exactly like this. Dense, mushy, crumbly, and not very good. I realized, though, that if someone is making this recipe, they're going to want it to taste good since they went through the effort to make it. Even if tasting good is not true to the book. If you want to make the authentic version, just swap all the flour for oat flour, and feel free to skip all the extended mixing steps, since there's no gluten to develop. As for the specific ingredients and flavors in this recipe, I needed a grain that was available at the store both in ground and un-ground forms, since I needed to include unground grain to achieve the 'grainy' texture Lift describes. I also wanted something without gluten, since if clema had gluten, it would almost certainly be used widely outside of Tashikk. Finally, I couldn't use corn or rice, since I was already using those for lavis and tallew. These requirements led me to oat flour. For the paste, since the Makabaki kingdoms take some inspiration from African cultures, I looked to North African food and came up with Harissa as the inspiration.",
  quotes:
    "The young man from before opened the door and tossed something out to her—a large baked roll of clemabread, thick and granular, with spicy paste at the center. (Edgedancer ch 6)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/clemabread-overview.jpg",
  ingredientSections: [
    {
      title: "Dough",
      ingredients: [
        {
          item: "oats",
          display: "1 cup steel cut oats"
        },
        {
          item: "wheatFlour",
          display: "2 - 2 1/2 cups all-purpose flour, divided"
        },
        {
          item: "yeast",
          display: "1 packet instant yeast"
        },
        {
          item: "water",
          display: "1 cup water, plus additional for boiling"
        },
        {
          item: "vegetableOil",
          display: "6 tbsp vegetable oil"
        },
        {
          item: "sugar",
          display: "2 tbsp granulated sugar"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "eggs",
          display: "1 egg"
        },
        {
          item: "oats",
          display: "1 cup oat flour, plus additional"
        }
      ]
    },
    {
      title: "Filling",
      ingredients: [
        {
          item: "hotPeppers",
          display: "1 oz chiles guajillo"
        },
        {
          item: "hotPeppers",
          display: "2 oz chiles ancho"
        },
        {
          item: "water",
          display: "water for soaking"
        },
        {
          item: "bellPepper",
          display: "1/2 red bell pepper"
        },
        {
          item: "caraway",
          display: "1/2 tsp caraway seeds"
        },
        {
          item: "coriander",
          display: "1/2 tsp coriander seeds"
        },
        {
          item: "cumin",
          display: "3/4 tsp cumin seeds"
        },
        {
          item: "garlicClove",
          display: "1 clove garlic"
        },
        {
          item: "oliveOil",
          display: "1/2 tbsp olive oil"
        },
        {
          item: "lemon",
          display: "1/4 tsp lemon juice"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        }
      ]
    }
  ],
  steps: [
    "Soak the chiles guajillo and ancho in enough hot water to cover until soft, about 1 hour. If they're still hard, cut or tear holes in the peppers to allow water inside and let soak a bit longer.",
    "Meanwhile, place the half bell pepper (after removing the seeds) cut side down on a baking sheet. Broil on the top rack until half the skin is blackened. Remove the pepper and place it in a ziploc bag. Seal the bag and let the pepper steam. Once it's cool, peel off the skin. Set aside.",
    "Place the caraway, coriander, and cumin seeds in a small dry skillet. Toast over medium heat, stirring or shaking frequently, about 5 minutes until the seeds start to pop. Remove from heat and grind with a spice grinder.",
    "While the chiles are soaking and pepper is steaming, start the dough. Put the steel cut oats in a saucepan and cover generously with water. Bring to a boil over high heat and boil for 5 minutes. Reduce heat if needed to stop it from boiling over. Strain the oats and set aside.",
    "Mix 1 1/2 cups all-purpose flour and the yeast in an electric mixing bowl, set aside.",
    "In a saucepan, combine the 1 cup water, vegetable oil, sugar, and 1 tsp salt. Heat over medium heat just until warm, about 110 degrees Fahrenheit.",
    "Add the liquid to the flour mixture along with the egg. Mix on low for 30 seconds, then scrape the sides. Mix on high for 3 minutes.",
    "Add the strained boiled oats and the oat flour. Attach the dough hook attachment to the mixer. Turn the mixer to low, and start adding the remaining 1 to 1 1/2 cups all-purpose flour. Add just enough so that the dough pulls away from the sides of the bowl and forms a moderately stiff dough. Continue mixing on low for 5 more minutes, then mix on medium low for 3 minutes. At any point, if dough starts sticking to the sides again, add a little flour.",
    "Form the dough into a ball, place back in the mixing bowl, then cover and let rise for 1 hour until double.",
    "Meanwhile, finish making the filling. Remove the soaked chiles from the water. Remove the stems and seeds, then place in a food processor. Also add the steamed peeled bell pepper, ground toasted spices, garlic, olive oil, lemon juice, and 1/2 tsp salt. Process to a paste.",
    "Once the dough has risen, punch it down. Sprinkle oat flour over your work surface. Divide dough into 12 pieces. One at a time, pat the piece into a thick disk about 4 inches across. Place 1 tablespoon of filling paste in the center. Fold the dough in half gently around the paste, then pull the ends up to the center and pinch together to form a ball. Place the dough balls in a greased 9x13 baking pan. Cover and let rise for 30 minutes until double in size.",
    "Preheat the oven to 375 degrees Fahrenheit. Bake for 20-25 minutes until tops are golden."
  ]
}
